import countriesList from 'countries-list/minimal/countries.en.min.json';

export const DEFAULT_LOCALE = 'en-GB';

export const DEFAULT_COUNTRY = 'GB';

export const DEFAULT_CURRENCY = 'GBP';

export const getCurrencySymbol = (): string => (
  new Intl.NumberFormat(
    DEFAULT_LOCALE,
    {
      style: 'currency',
      currency: DEFAULT_CURRENCY,
    }
  )
    ?.formatToParts(1)
    ?.find(x => x.type === 'currency')
    ?.value
    ?? ''
);

export const countriesOptions = Object.entries(countriesList)
  .map(([value, displayValue]) => ({ value, displayValue }))
  .sort((a, b) => {
    if (a.value === DEFAULT_COUNTRY) {
      return -1;
    }
    if (b.value === DEFAULT_COUNTRY) {
      return 1;
    }
    if (a.displayValue > b.displayValue) {
      return 1;
    }
    return -1;
  });
